import styled from 'styled-components';
import { FLEX_ROWS } from '../../../../../../../common/components/layout/FlexLayout';
import { Breakpoint, FONT_STACK } from '../../../../../../../common/styles/constants';
import { Detail } from '../Detail/Detail';

export const Wrapper = styled.div`
  ${FONT_STACK};

  ${Breakpoint.SMALL} {
    margin-right: 8px;
  }
`;

export const TagWrap = styled.div`
  ${FLEX_ROWS};
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const StyledDetail = styled(Detail)`
  margin-bottom: 4px;

  &:last-child {
    margin: 0;
  }
`;

export const SpecialOffer = styled.div`
  display: flex;
  margin: 0;
`;
